import * as React from "react";
function XlIcon() {
    return React.createElement("path", { d: "M7.92745 25.5071H32.0728V21.0466H7.92745V25.5071ZM7.92745 18.9527H32.0728V14.4815H7.92745V18.9527ZM7.92745 12.3875H32.0728V7.92697H7.92745V12.3875ZM5.8335 34.1663V5.83301H34.1667V34.1663H5.8335ZM7.92745 32.0723H32.0728V27.6011H7.92745V32.0723Z", fill: "currentColor" });
}
export default XlIcon;
//# sourceMappingURL=Xl.js.map